export const blogsArticle = '/blog/:username/article-new/:articleSlug/';
export const blogsMagazineArticle = '/magazin/article-new/:articleSlug/';

// TODO: Replace /forum/groups/work-in-progress/ with / when released
export const groupsPrefix = '/forum/groups/work-in-progress/'; // '/';
export const groupsList = `${groupsPrefix}list-of-groups/:type(public|private)/:category?/`;
export const groupsNewGroup = `${groupsPrefix}new-group/`;
export const groupsNewGroupExplanation = `${groupsNewGroup}`;
export const groupsNewGroupSelect = `${groupsNewGroup}select/`;
export const groupsNewGroupForm = `${groupsNewGroup}:type(public|private)/`;
export const groupsGroup = `${groupsPrefix}group/:groupId/`;
export const groupsGroupInfo = `${groupsPrefix}group/:groupId/detail/`;
export const groupsGroupEdit = `${groupsPrefix}group/:groupId/edit/`;
export const groupsGroupPhotos = `${groupsPrefix}group/:groupId/photos/`;
export const groupsGroupMembers = `${groupsPrefix}group/:groupId/members/`;
export const groupsGroupBlockMember = `${groupsPrefix}group/:groupId/block-member/`;
export const groupsGroupBlockedMembers = `${groupsPrefix}group/:groupId/blocked-members/`;
export const groupsGroupInvitedMembers = `${groupsPrefix}group/:groupId/invited-members/`;
export const groupsGroupInvitation = `${groupsPrefix}group/:groupId/invitation/:invitation/`;
export const groupsPhotoDetail = `${groupsPrefix}group/:groupId/:postSlug/:imageId`;
export const groupsPostDetail = `${groupsPrefix}group/:groupId/:postSlug/`;
export const groupsPostEdit = `${groupsPrefix}post/:postId/edit/`;
